import io from "socket.io-client";

const socket = io(`https://new-api.realm.chat/`);

export default socket;